var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 2.66663C8.36884 2.66663 8.66732 2.9651 8.66732 3.33329V12.6666C8.66732 13.0348 8.36884 13.3333 8.00065 13.3333C7.63246 13.3333 7.33398 13.0348 7.33398 12.6666V3.33329C7.33398 2.9651 7.63246 2.66663 8.00065 2.66663Z",
    fill: "#0E1111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66602 8.00004C2.66602 7.63185 2.96449 7.33337 3.33268 7.33337H12.666C13.0342 7.33337 13.3327 7.63185 13.3327 8.00004C13.3327 8.36823 13.0342 8.66671 12.666 8.66671H3.33268C2.96449 8.66671 2.66602 8.36823 2.66602 8.00004Z",
    fill: "#0E1111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.dfeddbb3656fd8e2f38767c820a80575.svg";
export { ForwardRef as ReactComponent };